<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2">{{ alert_msg }}</argon-alert>
      <div class="table-responsive p-0" v-if="tubeflList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                Numero di fabbrica
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                Numero di matricola
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Codice cliente
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tubeFL in tubeflList" :key="tubeFL._id">
              <table-tubefl-row :item="tubeFL" />
              <td class="align-middle">
                <div class="d-flex align-items-center justify-content-center gap-2">
                  <a class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Modifica"
                    href="javascript:;"
                      @click="openModalEdit(tubeFL._id)">
                      <i class="fa fa-pen"></i>
                  </a>
                  <tubefl-modal
                    :is-open="isModalFLOpen"
                    :idTubeFL="selectedTubeFLId"
                    @close="closeModalEdit"
                    @saved="handleTubeSaved"
                  />
                  <a @click.stop="openModal(tubeFL._id)"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Elimina"
                    href="javascript:;">
                    <i class="fa fa-trash"></i>
                  </a>
                  <delete-modal
                    :modalId="'deleteModal' + tubeFL._id"
                    :object="tubeFL"
                    @deleteObject="deleteTubeFL"
                    @closeModal="closeModal(tubeFL._id)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";
import tableTubeflRow from "./tableTubeFLRow.vue";
import TubeflModal from "@/views/tubefl/tubeFLModal.vue";

export default {
  name: "tubefl-table",
  props: {
    tubeflListProp: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      tubeflList: {},
      isModalFLOpen: false,
      selectedTubeFLId: null
    };
  },
  components: { ArgonAlert, DeleteModal, tableTubeflRow, TubeflModal },
  watch: {
    tubeflListProp: {
      handler(newVal) {
        this.tubeflList = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.tubeflList = this.tubeflListProp;
  },
  methods: {
    editTubeFL(tubeFLId) {
      router.push({ name: "Modifica tubo FluorTecno", params: { id: tubeFLId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push({ name: "Lista tubi FluorTecno" });
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteTubeFL(tubeFL) {
      try {
        const response = await axios.delete(
          this.$endpoint + "/tubefl/delete/" + tubeFL._id,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        if (response.data.status === "OK") {
          this.show_success = true;
          this.alert_msg = "Tubo FluorTecno eliminato con successo";
          
          // ✅ Rimuovi l'elemento dalla lista locale
          const index = this.tubeflList.findIndex(obj => obj._id === tubeFL._id);
          if (index !== -1) {
            this.tubeflList.splice(index, 1);
          }
          
          // ✅ Emetti evento al componente padre per aggiornare anche la lista principale
          this.$emit('tubeDeleted', tubeFL._id);
          
          // Nascondi messaggio dopo 3 secondi
          setTimeout(() => {
            this.show_success = false;
          }, 3000);
        }

        await this.closeModal(tubeFL._id);
      } catch (error) {
        console.error("Errore nell'eliminazione del tubo:", error);
        this.alert_msg = "Errore nell'eliminazione del tubo";
        this.show_success = false;
      }
    },

    openModalEdit(tubeFLId = null) {
      this.selectedTubeFLId = tubeFLId;
      this.isModalFLOpen = true;
    },
    closeModalEdit() {
      this.isModalFLOpen = false;
      this.selectedTubeFLId = null;
    },
    async handleTubeSaved(savedTubeData) {
      console.log("Tubo salvato nella tabella:", savedTubeData);
      
      // Trova l'indice del tubo modificato
      const index = this.tubeflList.findIndex(tube => tube._id === this.selectedTubeFLId);
      
      if (index !== -1) {
        if (savedTubeData && savedTubeData._id) {
          this.tubeflList[index] = savedTubeData;
        } else {
          await this.reloadSingleTube(this.selectedTubeFLId, index);
        }
      }
      
      // Mostra messaggio di successo
      this.show_success = true;
      this.alert_msg = "Tubo FluorTecno aggiornato con successo";
      
      // ✅ Emetti evento al componente padre
      this.$emit('tubeUpdated', savedTubeData);
      
      // Nascondi messaggio dopo 3 secondi
      setTimeout(() => {
        this.show_success = false;
      }, 3000);
    },
    async reloadSingleTube(tubeFLId, index) {
      try {
        const response = await axios.get(
          this.$endpoint + "/tubefl/show/" + tubeFLId,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        if (response.data.status === "OK") {
          this.tubeflList[index] = response.data.data;
        }
      } catch (error) {
        console.error("Errore nel ricaricamento del tubo:", error);
      }
    }
  },
};
</script>
